/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var _ = require('underscore');
var Backbone = require('backbone');
var Marionette = require('backbone.marionette');
var Radio = require('backbone.radio');

var UIUtil = require('psa-core/util/ui');

var modelGet = require('common/util/modelGet');
var SideNavSectionView = require('common/views/SideNavSectionView');
var BreadcrumbView = require('common/views/BreadcrumbView');
var DropdownView = require('common/views/DropdownView');
var ConfirmationModalView = require('common/views/ConfirmationModalView');
var ContentServerLinkView = require('common/views/ContentServerLinkView');

var SubmitEntityAudit = require('../services/SubmitEntityAudit');
var DepAuditDetailsSectionView = require('./DepAuditDetailsSectionView');

var tmplDepAuditDashboardView = require('../templates/DepAuditDashboardView.hbs');

module.exports = Marionette.LayoutView.extend({
  template: tmplDepAuditDashboardView,

  className: 'dep-audit-dashboard-view container-fluid',

  ui: {
    auditWrapper: '.audit-wrapper',
    breadcrumb: '.breadcrumb-container',
    csLinkContainer: '.cs-link-container',
    auditActionDropDown: '.dropdown-container'
  },

  regions: {
    auditWrapper: '@ui.auditWrapper',
    csLinkContainer: '@ui.csLinkContainer',
    breadcrumb: '@ui.breadcrumb',
    auditActionDropDown: '@ui.auditActionDropDown'
  },

  onBeforeShow: function() {
    var audit = this.model.get('audit') || {};
    var entityIdentifiers = this.model.get('entityIdentifiers');
    var auditId = this.model.get('auditId');
    var entityId = this.model.get('entityId');
    var entityName = modelGet(this.model, 'entityIdentifiers.entityName');
    var auditsCSFolderId = this.model.get('auditsCSFolderId');
    var csFolderId = audit.csFolderId;

    this.showChildView(
      'auditActionDropDown',
      new DropdownView({
        rightAlign: true,
        model: new Backbone.Model({
          name: 'Audit Actions',
          options: [
            {
              text: 'Edit Audit',
              link: '#dep/entity/' + entityId + '/audit/' + auditId + '/edit'
            },
            {
              text: 'Delete Audit',
              onClick: this.onClickDelete.bind(this)
            }
          ]
        })
      })
    );

    this.showChildView(
      'breadcrumb',
      new BreadcrumbView({
        breadcrumbs: [
          {
            link: '#dep/dashboard',
            text: 'Home'
          },
          {
            link: '#dep/entity/' + entityId + '/dashboard',
            text: entityName
          },
          {
            text: audit.auditDate + ' - ' + audit.auditType
          }
        ]
      })
    );

    this.showChildView(
      'csLinkContainer',
      new ContentServerLinkView({
        model: new Backbone.Model({
          buttonText: 'Open Audit Folder',
          contentServerId: csFolderId ? csFolderId : auditsCSFolderId
        })
      })
    );

    this.audit = new SideNavSectionView({
      useNavigationButtons: false,
      collection: new Backbone.Collection([
        {
          id: 'auditDetails',
          title: 'Audit Details',
          view: new DepAuditDetailsSectionView({
            viewMode: 'int',
            model: new Backbone.Model(_.extend(audit, { entityIdentifiers: entityIdentifiers }))
          })
        },
        {
          id: 'notes',
          title: 'Notes',
          view: Radio.channel('dp').request('build:notes-view', {
            objectId: auditId,
            objectTypeId: 'ENTITY_AUDIT'
          })
        },
        {
          id: 'auditLog',
          title: 'Audit Log',
          view: Radio.channel('dp').request('build:audit-log-view', {
            objectId: auditId,
            objectTypeId: 'ENTITY_AUDIT'
          })
        }
      ])
    });
    this.showChildView('auditWrapper', this.audit);
  },

  onClickDelete: function() {
    var self = this;
    var message = 'Are you sure you want to delete this audit?';
    UIUtil.showModal({
      title: 'Confirm Deleting Audit',
      view: new ConfirmationModalView({
        confirmText: 'Delete Audit',
        model: new Backbone.Model({
          message: message,
          onConfirm: function() {
            var auditId = self.model.get('auditId');
            return SubmitEntityAudit({ auditId: auditId, isDeleted: '1' });
          },
          onConfirmDone: function() {
            var entityId = self.model.get('entityId');
            Radio.channel('navigate').trigger('show:int:dp:entity', entityId);
          }
        })
      })
    });
  }
});
